import { useEffect } from 'react'
import { Loader2 } from "lucide-react"
import { supabase } from '@/lib/supabase'

export default function LogoutPage() {

    // Function to clear all auth data
    const clearAuthData = () => {
        // Clear all Supabase auth data
        for (const key in localStorage) {
            if (key.includes('supabase.auth') || key.includes('sb-')) {
                localStorage.removeItem(key)
            }
        }
        // Also clear cookies related to auth
        document.cookie.split(';').forEach(cookie => {
            const [name] = cookie.trim().split('=')
            if (name.includes('sb-')) {
                document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`
            }
        })
    }

    useEffect(() => {
        async function performLogout() {
            try {
                // Check if session exists before signing out
                const { data } = await supabase.auth.getSession()
                
                if (data.session) {
                    await supabase.auth.signOut({ scope: 'global' })
                }
                
                // Clear all auth data
                clearAuthData()
                
                // Navigate to home
                window.location.href = '/?forceLogout=' + Date.now()
            } catch (error) {
                console.error('Error during logout:', error)
                clearAuthData()
                window.location.href = '/?forceLogout=' + Date.now()
            }
        }

        performLogout()
    }, [])

    return (
        <div className="min-h-screen flex items-center justify-center">
            <div className="text-center space-y-4">
                <Loader2 className="h-8 w-8 animate-spin mx-auto" />
                <p className="text-lg">Logging out...</p>
            </div>
        </div>
    )
} 